<template>
  <div v-if="loading">
    <spinner />
  </div>
  <sport-store-container
    v-else
    :organization="organization"
    :schema="schema"
    :title="$t('membership')"
    :cover-url="organization.imageUrls.membershipCoverUrl"
  />
</template>

<script>
import SportStoreContainer from '@/components/accreditations/organization-store/SportStoreContainer.vue'
import { GET_ORGANIZATION_BY_SLUG } from '@/graphql/organization.graphql'
import { createAttendeeSchema } from '@/utils'

export default {
  name: 'sport-memberships-store-container',
  components: { SportStoreContainer },
  props: {
    organizationSlug: String,
  },
  data() {
    return {
      organization: null,
      schema: {},
      loading: true,
    }
  },
  apollo: {
    getOrganizationBySlug: {
      query: GET_ORGANIZATION_BY_SLUG,
      variables() {
        return { organizationSlug: this.organizationSlug }
      },
      manual: true,
      result({ data, loading }) {
        if (!loading && data) {
          this.organization = data.getOrganizationBySlug
          if (this.organization.attendeeFields.membershipFields) {
            this.schema = createAttendeeSchema(this.organization.attendeeFields.membershipFields)
          }

          this.loading = false
        }
      },
    },
  },
}
</script>

<style scoped></style>
